<template>
  <div class="campaigns-wrapper">
    <div class="campaigns-header d-flex justify-content-center align-center px-20 px-sm-30">
      <div class="campaigns-container px-20 mx-auto relative">
        <a href="#" @click.prevent="$router.back()" class="mobile-back">
          <div class="mobile-back-btn Arrow-Macro"></div>
        </a>
        <h1>{{ pageTitle }}</h1>
      </div>
    </div>
    <div class="campaigns-body py-20 py-sm-30 py-lg-40 px-20 px-sm-30">
      <div class="campaigns-container mx-auto">
        <div class="campaigns-content d-md-grid grid-cols-md-12 gap-md-30">
          <div class="col-span-md-12 col-span-lg-8 col-start-lg-3" v-html="pageContent"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { name as pkgName } from '~/package.json'

  export default {
    scrollToTop: true,

    async asyncData({ params, store, error }) {
      let pageContent = null
      let pageTitle = null

      try {
        const action =
          params.slug === 'mastercard-platinum'
            ? ['fetch_contents_page', 'mastercard-campaign-terms']
            : ['fetch_campaign_terms', params.slug]
        const responseData = await store.dispatch(...action)

        if (responseData?.content) {
          pageContent = responseData.content
          pageTitle = responseData.title
        } else {
          pageContent = ''
          pageTitle = ''
        }
      } catch (err) {
        pageContent = ''
        pageTitle = ''
        error({ statusCode: 404, message: 'Post not found' }, { statusCode: 400, message: 'Post not found' })
      }

      return {
        pageContent,
        pageTitle,
      }
    },

    head() {
      return {
        title: [this.pageTitle, '-', pkgName].join(' '),
        meta: [{ name: 'robots', content: 'noindex' }],
      }
    },
  }
</script>
